import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '@app/_services/user.service';
import { AlertService } from '@app/_services';
import { ReportService } from '@app/_components/report';
import { TaskService } from '@app/_components/task';
import { TaskTypeEnum, TaskStatusEnum, PriorityEnum, PermissionsEnum } from '@app/_helpers';


@Component({
    selector: 'app-team-users-select',
    templateUrl: './team-user-select.component.html',
    styleUrls: ['./team-user-select.component.css'],
    standalone: false
})

export class TeamUserSelectComponent implements OnInit
{

	@Input() taskId: number;
	@Input() taskUsers: any[] = [];
	@Output() messageEvent = new EventEmitter<string>();
	@Input() taskApi: any;


	// list
	userSummaryList: any[] = [];
	recordTotal: number;
	loading = true;
	permissions = [
		{ value: 0, name: 'None' },
		{ value: 100, name: 'View Only' },
		{ value: 300, name: 'View and Edit' },
		{ value: 400, name: 'Task Administrator' },

	];
	get permissionsEnum() { return PermissionsEnum; }

	form1: UntypedFormGroup;


	constructor(private router: Router,
		private activatedRoute: ActivatedRoute,
		private userService: UserService,
		private reportService: ReportService,
		private taskService: TaskService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder) { }

	ngOnInit()
	{
		// if passed the taskApi
		if (this.taskApi)
		{
			if (!this.taskId) { this.taskId = this.taskApi.taskId; }
			this.taskUsers = (this.taskApi.taskUsers ? this.taskApi.taskUsers : []);
		}
		//this.getUserSummaryList();
		this.form1 = this.formBuilder.group({

			taskId: [this.taskId],
			view: [],
			edit: [],
			delete: [],
			admin: [],
			level: []
		});
	}



	displayPaginator()
	{
		if (this.userSummaryList && this.userSummaryList.length > 25)
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	getUserSummaryList()
	{
		this.reportService.userSummaryList(200).pipe(first()).subscribe(

			data =>
			{
				// console.log('reports are: ' + JSON.stringify(data));
				this.userSummaryList = data.data.userSummaryList;
				this.recordTotal = this.userSummaryList.length;
				console.log('teams ' + JSON.stringify(this.userSummaryList));
			},
			error =>
			{
				// console.log('user-select ERROR: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ this.loading = false; }
		);
	}

	onRowEditInit(taskUser: any)
	{

	}

	onRowEditSave(taskUser: any)
	{
		console.log('update! ' + JSON.stringify(taskUser));
		if (this.taskId == null)
		{
			this.alertService.error('Please enter a task name first');
		}
		else
		{
			taskUser.permission = taskUser.permission.value;
			this.updateTaskUser(taskUser);
		}
	}

	onRowEditCancel(taskUser: any, index: number)
	{
	}

	onAddTaskUser(event)
	{
		if (this.taskId == null)
		{
			this.alertService.error('Please enter a task name first');
		}
		else
		{
			// assemble the payload manually since we are using primeng
			// when adding assign just basic 'view only' access.
			console.log('onSelect: ' + JSON.stringify(event));
			let data: any = {};
			data.taskId = this.taskId;
			data.userId = event.userId;
			console.log('onSelect: ' + JSON.stringify(data));
			this.addTaskUser(data);
		}
	}


	addTaskUser(taskUser)
	{
		this.taskService.addTaskUser(taskUser).pipe(first()).subscribe(
			res =>
			{
				this.alertService.success(res, true);
				this.taskUsers.unshift(res.data.taskUser);
				console.log('BOOM: ' + JSON.stringify(res.data.taskUser));

			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}
	updateTaskUser(taskUser)
	{
		this.taskService.updateTaskUser(taskUser).pipe(first()).subscribe(

			data =>
			{
				// console.log('updateUserContact are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}
}
